<template>
    <div>
        Users list
    </div>
</template>

<script>
export default {
    name: "UserList"
}
</script>